<div>
	<div class="left-buttons">
		<app-player-button (click)="up.emit()">
			<img src="/assets/img/up-arrow.svg" />
		</app-player-button>

		<app-player-button (click)="info.emit()">
			<img src="/assets/img/info.svg" />
		</app-player-button>
	</div>

	@if (activity() && activity()!.active_text) {
		<app-header-activity-title class="title" [nz-tooltip]="activity()!.active_text!.name">
			{{ activity()!.active_text!.name }}
		</app-header-activity-title>
	}

	@if (isStrideCourse() === true) {
		<ng-template #accountTemplate>
			<a (click)="logout()">Logout</a>
		</ng-template>
		<app-player-button nz-popover nzPopoverTrigger="click" [nzPopoverContent]="accountTemplate">
			<img src="/assets/img/account-icon.svg" [style.filter]="'brightness(0)'" />
			&nbsp; Account
		</app-player-button>
	}

	@if (isStrideCourse() === false) {
		@if (enableNext()) {
			<div class="right-buttons">
				<app-player-button (click)="next.emit()">
					Next Activity
					<img src="/assets/img/right-arrow.svg" />
				</app-player-button>
			</div>
		}
	}
</div>
